export default __webpack_public_path__ + "static/media/phoebee.81131792.JPG";